/**
 * breakpoints определены без какой либо привязки к дизайн-макетам,
 * а только чтобы максимально избежать появление вертикального скролла.
 */
export const MEDIA_HEIGHT_BREAKPOINT_1 = '632px';

export const CARD_WIDTH = 340;
export const CARD_HEIGHT = 560;
export const CARD_WIDTH_SMALL_1 = 300;
export const CARD_HEIGHT_SMALL_1 = 495;

export const VARIANT_WIDTH_X2 = 230;
export const VARIANT_HEIGHT_X2 = 153;
// размер сработает на MEDIA_HEIGHT_BREAKPOINT_1
export const VARIANT_WIDTH_X2_SMALL_1 = 180;

export const VARIANT_WIDTH_X3 = 170;
export const VARIANT_HEIGHT_X3 = 113;
// размер сработает на MEDIA_HEIGHT_BREAKPOINT_1
export const VARIANT_WIDTH_X3_SMALL_1 = 146;

export const VIEWED_STORIES_LS_KEY = 'viewed_stories';

// https://www.w3.org/TR/uievents-key/#keys-special
export const LEFT_ARROW_KEY = 'ArrowLeft';
export const RIGHT_ARROW_KEY = 'ArrowRight';

// PubSub флаг в PushWoosh
export const STORIES_MODAL_STATE = 'stories.modal';
